module.exports = __webpack_public_path__ + "img/exam.16245681.svg";